var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"7.74769","cy":"7.91213","rx":"6.26087","ry":"6.48","strokeWidth":"1.353","key":0}),React.createElement("path",{"d":"M11.5044 13.168L16.5827 18.352","strokeWidth":"1.353","key":1})]);
}

Search.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = Search;

Search.default = Search;
